import React, { Component } from 'react'
import { Form, FormGroup, FormControl } from 'react-bootstrap'
import Button from '../Buttons'
import { Link } from 'react-router';

export default class Newsletter extends Component {
  render () {
    return (
    	<div className="newsletter-form">
  		 	<div className="newsletter-title"> Suscríbase a Nuestro Newsletter y reciba información relevante sobre la División </div>
        <Form inline >
          <FormGroup controlId="formNewsletter">
            <FormControl type="text" placeholder="Email" />
          </FormGroup>
          <Button type="submit" text="Suscribirme" classes="btn-primary btn-news" />
        </Form>
        <Link to="/newsletters" className="link-newsletter hidden-xs">
          Consultar Newsletters
          <i className="fa fa-long-arrow-right"></i>
        </Link>
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Newsletter/index.js